import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MatMenuModule } from '@angular/material/menu';
import { TranslateUiModule } from '@core/translation/translate-ui.module';
import { CommonPipesModule } from '@ui-kit/pipes/common-pipes.module';
import { SumHoursComponent } from './sum-hours.component';

@NgModule({
  declarations: [SumHoursComponent],
  exports: [SumHoursComponent],
  imports: [CommonModule, MatMenuModule, TranslateUiModule, CommonPipesModule]
})
export class SumHoursModule {}
